package com.evoapps.evoshift.ui.more

import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.TopBarAction
import com.evoapps.evoshift.widgets.helpAction
import com.evoapps.evoshift.ui.notifications.notificationsAction
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import com.evoapps.evoshift.ui.adaptive.rowClickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.KeyboardArrowRight
import androidx.compose.material.icons.filled.AddBusiness
import androidx.compose.material.icons.filled.AttachMoney
import androidx.compose.material.icons.filled.CalendarMonth
import androidx.compose.material.icons.filled.Campaign
import androidx.compose.material.icons.filled.EventAvailable
import androidx.compose.material.icons.filled.EventBusy
import androidx.compose.material.icons.filled.Notifications
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.PersonSearch
import androidx.compose.material.icons.filled.Policy
import androidx.compose.material.icons.filled.School
import androidx.compose.material.icons.filled.PointOfSale
import androidx.compose.material.icons.filled.RequestQuote
import androidx.compose.material.icons.filled.Repeat
import androidx.compose.material.icons.filled.Settings
import androidx.compose.material.icons.filled.Schedule
import androidx.compose.material.icons.filled.Share
import androidx.compose.material.icons.filled.Checklist
import androidx.compose.material.icons.filled.SwapHoriz
import androidx.compose.material.icons.filled.WorkspacePremium
import androidx.compose.material.icons.filled.VolunteerActivism
import androidx.compose.material3.Badge
import androidx.compose.material3.CenterAlignedTopAppBar
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.navigation.MoreEntry
import com.evoapps.evoshift.ui.Cream
import com.evoapps.evoshift.ui.DarkGold
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.GoldMetallicBrush
import com.evoapps.evoshift.ui.adaptive.CentredLazyColumn
import com.evoapps.evoshift.ui.adaptive.FormMaxWidth
import com.evoapps.evoshift.ui.adaptive.DashboardColumns
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.ui.adaptive.WindowWidthClass
import com.evoapps.evoshift.ui.adaptive.handCursor
import com.evoapps.evoshift.widgets.RegularCard
import com.evoapps.evoshift.widgets.StandoutCard
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.announcements_title
import evoshift.composeapp.generated.resources.hiring_title
import evoshift.composeapp.generated.resources.cost_rules_title
import evoshift.composeapp.generated.resources.dashboard_notifications
import evoshift.composeapp.generated.resources.more_add_workplace
import evoshift.composeapp.generated.resources.more_profile
import evoshift.composeapp.generated.resources.more_profile_hint
import evoshift.composeapp.generated.resources.more_section_account
import evoshift.composeapp.generated.resources.more_section_work
import evoshift.composeapp.generated.resources.more_section_workplace
import evoshift.composeapp.generated.resources.more_switch_workplace
import evoshift.composeapp.generated.resources.more_unread
import evoshift.composeapp.generated.resources.more_requests_pending
import evoshift.composeapp.generated.resources.more_workplace_settings
import evoshift.composeapp.generated.resources.checklists_title
import evoshift.composeapp.generated.resources.nav_absences
import evoshift.composeapp.generated.resources.nav_availability
import evoshift.composeapp.generated.resources.nav_money
import evoshift.composeapp.generated.resources.policies_title
import evoshift.composeapp.generated.resources.recommend_row_hint
import evoshift.composeapp.generated.resources.recommend_title
import evoshift.composeapp.generated.resources.training_title
import evoshift.composeapp.generated.resources.nav_more
import evoshift.composeapp.generated.resources.nav_my_shifts
import evoshift.composeapp.generated.resources.nav_requests
import evoshift.composeapp.generated.resources.sales_import_title
import evoshift.composeapp.generated.resources.subscription_title
import evoshift.composeapp.generated.resources.tips_title
import evoshift.composeapp.generated.resources.work_hours_title
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource

/** Test tag of a More row; `more_<entry>`. */
fun MoreEntry.testTag(): String = "more_${name.lowercase()}"

/**
 * The More tab (SH-42), like EVoLabels' Settings tab: the person on top (to the profile), then
 * the sections that have no tab for this role, the workplace and the account. Only what the role
 * may use is listed (see [com.evoapps.evoshift.navigation.moreEntriesFor]).
 */
@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun MoreScreen(
    /** SH-247: null while the person's profile is not read yet (the header's placeholder). */
    userName: String?,
    workplaceName: String?,
    entries: List<MoreEntry>,
    unreadNotifications: Int,
    onEntry: (MoreEntry) -> Unit,
    /** SH-164: requests waiting for the person's decision, on the Requests row. */
    pendingRequests: Int = 0
) {
    Scaffold(
        containerColor = Cream,
        topBar = {
            EvoTopBar(title = stringResource(Res.string.nav_more))
        }
    ) { padding ->
        val groups = listOf(
            Res.string.more_section_work to entries.filter { it in WorkEntries },
            Res.string.more_section_workplace to entries.filter { it in WorkplaceEntries },
            Res.string.more_section_account to entries.filter { it in AccountEntries }
        ).filter { it.second.isNotEmpty() }

        @Composable
        fun Section(title: StringResource, rows: List<MoreEntry>) = MoreSection(
            title = title,
            rows = rows,
            workplaceName = workplaceName,
            unreadNotifications = unreadNotifications,
            pendingRequests = pendingRequests,
            onEntry = onEntry
        )

        val widthClass = LocalWindowWidthClass.current
        val columns = moreColumnsFor(widthClass)
        // SH-230: on wide windows the profile across the top and the sections side by side,
        // instead of a narrow column in the middle of the screen; phones keep the list.
        CentredLazyColumn(
            maxWidth = if (columns > 1) widthClass.wideContentMaxWidth else FormMaxWidth,
            modifier = Modifier.padding(padding),
            contentPadding = PaddingValues(if (columns > 1) 24.dp else 16.dp),
            verticalArrangement = Arrangement.spacedBy(if (columns > 1) 24.dp else 16.dp)
        ) {
            if (MoreEntry.PROFILE in entries) {
                item("profile") { ProfileHeader(userName, onClick = { onEntry(MoreEntry.PROFILE) }) }
            }
            if (columns > 1) {
                item("sections") {
                    val spread = spreadSections(groups.map { it.second.size }, columns)
                    DashboardColumns(
                        columns = spread.map { column ->
                            column.map { index -> val section: @Composable () -> Unit = { Section(groups[index].first, groups[index].second) }; section }
                        },
                        spacing = 24.dp
                    )
                }
            } else {
                groups.forEach { (title, rows) -> item(title.key) { Section(title, rows) } }
            }
        }
    }
}

/** SH-230: one column of sections on phones and small tablets, two on a tablet in landscape, three on a laptop. */
fun moreColumnsFor(widthClass: WindowWidthClass): Int = when (widthClass) {
    WindowWidthClass.COMPACT, WindowWidthClass.MEDIUM -> 1
    WindowWidthClass.EXPANDED -> 2
    WindowWidthClass.LARGE, WindowWidthClass.EXTRA_LARGE -> 3
}

/**
 * SH-230: the sections (their row counts, in order) spread over [columns] columns of about even
 * height: each goes to the shortest column so far, so the columns stay in reading order and
 * no column is left far longer than the others. Returns each column's section indexes; empty
 * columns are left out.
 */
fun spreadSections(sizes: List<Int>, columns: Int): List<List<Int>> {
    if (columns <= 1) return listOf(sizes.indices.toList())
    val spread = List(columns) { mutableListOf<Int>() }
    val heights = IntArray(columns)
    sizes.forEachIndexed { index, size ->
        val shortest = heights.indices.minBy { heights[it] }
        spread[shortest] += index
        // A section's title counts as about one row.
        heights[shortest] += size + 1
    }
    return spread.filter { it.isNotEmpty() }
}

@Composable
private fun MoreSection(
    title: StringResource,
    rows: List<MoreEntry>,
    workplaceName: String?,
    unreadNotifications: Int,
    pendingRequests: Int,
    onEntry: (MoreEntry) -> Unit
) {
    Column {
        Text(
            stringResource(title).uppercase(),
            style = MaterialTheme.typography.labelMedium,
            fontWeight = FontWeight.Bold,
            color = DeepNavy.copy(alpha = 0.7f),
            modifier = Modifier.padding(start = 8.dp, bottom = 8.dp)
        )
        RegularCard {
            rows.forEachIndexed { index, entry ->
                if (index > 0) HorizontalDivider(color = DeepNavy.copy(alpha = 0.08f))
                MoreRow(
                    entry = entry,
                    subtitle = when (entry) {
                        MoreEntry.SWITCH_WORKPLACE -> workplaceName?.takeIf { it.isNotBlank() }
                        MoreEntry.NOTIFICATIONS -> unreadNotifications.takeIf { it > 0 }
                            ?.let { stringResource(Res.string.more_unread, it) }
                        MoreEntry.REQUESTS -> pendingRequests.takeIf { it > 0 }
                            ?.let { stringResource(Res.string.more_requests_pending, it) }
                        MoreEntry.RECOMMEND -> stringResource(Res.string.recommend_row_hint)
                        else -> null
                    },
                    badge = when (entry) {
                        MoreEntry.NOTIFICATIONS -> unreadNotifications
                        MoreEntry.REQUESTS -> pendingRequests
                        else -> 0
                    },
                    onClick = { onEntry(entry) }
                )
            }
        }
    }
}

private val WorkEntries = setOf(
    MoreEntry.MY_SHIFTS, MoreEntry.AVAILABILITY, MoreEntry.ABSENCES, MoreEntry.REQUESTS, MoreEntry.MONEY, MoreEntry.WORK_HOURS, MoreEntry.ANNOUNCEMENTS,
    MoreEntry.TIPS, MoreEntry.HIRING
)
private val WorkplaceEntries = setOf(
    MoreEntry.SWITCH_WORKPLACE, MoreEntry.POLICIES, MoreEntry.TRAINING, MoreEntry.WORKPLACE_SETTINGS, MoreEntry.CHECKLISTS, MoreEntry.RECURRING_COSTS,
    MoreEntry.SALES_IMPORT,
    MoreEntry.ADD_WORKPLACE
)
// The profile has the header card.
private val AccountEntries = setOf(MoreEntry.NOTIFICATIONS, MoreEntry.RECOMMEND, MoreEntry.SUBSCRIPTION)

@Composable
private fun ProfileHeader(userName: String?, onClick: () -> Unit) {
    StandoutCard(onClick = onClick, modifier = Modifier.fillMaxWidth().handCursor().testTag(MoreEntry.PROFILE.testTag())) {
        // SH-247: the name and its initial fade in once the profile is read (no "Profile" first).
        com.evoapps.evoshift.widgets.LoadingSwap(known = userName != null, placeholder = { ProfileHeaderPlaceholder() }) {
            ProfileHeaderContent(userName.orEmpty())
        }
    }
}

/** The header's navy card contents while the name is not known: the picture and two lines. */
@Composable
private fun ProfileHeaderPlaceholder() {
    com.evoapps.evoshift.widgets.SkeletonArea(Modifier.fillMaxWidth()) {
        Row(Modifier.padding(16.dp), verticalAlignment = Alignment.CenterVertically) {
            com.evoapps.evoshift.widgets.SkeletonBlock(Modifier.size(48.dp), CircleShape)
            Spacer(Modifier.width(16.dp))
            Column(Modifier.weight(1f)) {
                com.evoapps.evoshift.widgets.SkeletonText(style = MaterialTheme.typography.titleMedium, widthFraction = 0.5f)
                com.evoapps.evoshift.widgets.SkeletonText(style = MaterialTheme.typography.bodySmall, widthFraction = 0.7f)
            }
            Icon(Icons.AutoMirrored.Filled.KeyboardArrowRight, contentDescription = null, tint = DarkGold)
        }
    }
}

@Composable
private fun ProfileHeaderContent(userName: String) {
    Box(Modifier.fillMaxWidth()) {
        Row(Modifier.padding(16.dp), verticalAlignment = Alignment.CenterVertically) {

            Box(
                Modifier.size(48.dp).clip(CircleShape).background(GoldMetallicBrush),
                contentAlignment = Alignment.Center
            ) {
                Text(
                    userName.trim().firstOrNull()?.uppercase() ?: "•",
                    color = DeepNavy,
                    fontWeight = FontWeight.Bold,
                    style = MaterialTheme.typography.titleLarge
                )
            }
            Spacer(Modifier.width(16.dp))
            Column(Modifier.weight(1f)) {
                Text(
                    userName.ifBlank { stringResource(Res.string.more_profile) },
                    style = MaterialTheme.typography.titleMedium,
                    fontWeight = FontWeight.Bold,
                    color = Color.White,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                Text(
                    stringResource(Res.string.more_profile_hint),
                    style = MaterialTheme.typography.bodySmall,
                    color = Color.White.copy(alpha = 0.7f)
                )
            }
            Icon(Icons.AutoMirrored.Filled.KeyboardArrowRight, contentDescription = null, tint = DarkGold)
        }
    }
}

@Composable
private fun MoreRow(entry: MoreEntry, subtitle: String?, badge: Int, onClick: () -> Unit) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .rowClickable(onClick)
            .testTag(entry.testTag())
            .padding(horizontal = 16.dp, vertical = 14.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Icon(entry.icon(), contentDescription = null, tint = DeepNavy)
        Spacer(Modifier.width(16.dp))
        Column(Modifier.weight(1f)) {
            Text(stringResource(entry.label()), style = MaterialTheme.typography.bodyLarge, color = DeepNavy, fontWeight = FontWeight.Medium)
            subtitle?.let {
                Text(it, style = MaterialTheme.typography.bodySmall, color = DeepNavy.copy(alpha = 0.6f), maxLines = 1, overflow = TextOverflow.Ellipsis)
            }
        }
        if (badge > 0) {
            Badge(containerColor = DarkGold, contentColor = DeepNavy, modifier = Modifier.testTag("${entry.testTag()}_badge")) {
                Text(if (badge > 9) "9+" else badge.toString())
            }
            Spacer(Modifier.width(8.dp))
        }
        Icon(Icons.AutoMirrored.Filled.KeyboardArrowRight, contentDescription = null, tint = DeepNavy.copy(alpha = 0.4f))
    }
}

private fun MoreEntry.icon(): ImageVector = when (this) {
    MoreEntry.MY_SHIFTS -> Icons.Default.CalendarMonth
    MoreEntry.AVAILABILITY -> Icons.Default.EventAvailable
    MoreEntry.ABSENCES -> Icons.Default.EventBusy
    MoreEntry.REQUESTS -> Icons.Default.RequestQuote
    MoreEntry.MONEY -> Icons.Default.AttachMoney
    MoreEntry.WORK_HOURS -> Icons.Default.Schedule
    MoreEntry.ANNOUNCEMENTS -> Icons.Default.Campaign
    MoreEntry.POLICIES -> Icons.Default.Policy
    MoreEntry.TRAINING -> Icons.Default.School
    MoreEntry.TIPS -> Icons.Default.VolunteerActivism
    MoreEntry.HIRING -> Icons.Default.PersonSearch
    MoreEntry.SWITCH_WORKPLACE -> Icons.Default.SwapHoriz
    MoreEntry.WORKPLACE_SETTINGS -> Icons.Default.Settings
    MoreEntry.CHECKLISTS -> Icons.Default.Checklist
    MoreEntry.RECURRING_COSTS -> Icons.Default.Repeat
    MoreEntry.SALES_IMPORT -> Icons.Default.PointOfSale
    MoreEntry.ADD_WORKPLACE -> Icons.Default.AddBusiness
    MoreEntry.NOTIFICATIONS -> Icons.Default.Notifications
    MoreEntry.PROFILE -> Icons.Default.Person
    MoreEntry.RECOMMEND -> Icons.Default.Share
    MoreEntry.SUBSCRIPTION -> Icons.Default.WorkspacePremium
}

private fun MoreEntry.label(): StringResource = when (this) {
    MoreEntry.MY_SHIFTS -> Res.string.nav_my_shifts
    MoreEntry.AVAILABILITY -> Res.string.nav_availability
    MoreEntry.ABSENCES -> Res.string.nav_absences
    MoreEntry.REQUESTS -> Res.string.nav_requests
    MoreEntry.MONEY -> Res.string.nav_money
    MoreEntry.WORK_HOURS -> Res.string.work_hours_title
    MoreEntry.ANNOUNCEMENTS -> Res.string.announcements_title
    MoreEntry.POLICIES -> Res.string.policies_title
    MoreEntry.TRAINING -> Res.string.training_title
    MoreEntry.TIPS -> Res.string.tips_title
    MoreEntry.HIRING -> Res.string.hiring_title
    MoreEntry.SWITCH_WORKPLACE -> Res.string.more_switch_workplace
    MoreEntry.WORKPLACE_SETTINGS -> Res.string.more_workplace_settings
    MoreEntry.CHECKLISTS -> Res.string.checklists_title
    MoreEntry.RECURRING_COSTS -> Res.string.cost_rules_title
    MoreEntry.SALES_IMPORT -> Res.string.sales_import_title
    MoreEntry.ADD_WORKPLACE -> Res.string.more_add_workplace
    MoreEntry.NOTIFICATIONS -> Res.string.dashboard_notifications
    MoreEntry.PROFILE -> Res.string.more_profile
    MoreEntry.RECOMMEND -> Res.string.recommend_title
    MoreEntry.SUBSCRIPTION -> Res.string.subscription_title
}
